import { useEffect, useState, Suspense, lazy } from "react";
// import "./App.css"; moved to index.css
import { HelmetProvider } from "react-helmet-async";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import jsonData from "./components/ai-branding.json";  
import axios from "axios";
import LoadingSpinner from "./components/LoadingSpinner";

const CookieSetting = lazy(() => 
  new Promise(resolve => {
    setTimeout(() => resolve(import("cookiesetting-component")),3000);
  }).then(module => ({default: module.CookieSetting}))
);

const MainPage = lazy(() => import("./components/MainPage/MainPage"))

function App() {
  const [links, setLinks] = useState(null); // Set initial state as null
  const appVersion = appversion.version;
  
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };
    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);
  
  return (
    <HelmetProvider>
      <div className="bodyContainer">
        <CacheBuster
          currentVersion={appVersion}
          isEnabled={true}
          isVerboseMode={false}
          metaFileDirectory={process.env.PUBLIC_URL}
        >
          <main>
            <Suspense fallback={<LoadingSpinner />}>
              <MainPage />
            </Suspense>
          </main>
          <Suspense fallback={null}>
            <CookieSetting 
              privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
              configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
              analytics={process.env.REACT_APP_ANALYTICS_PATH}
            />
          </Suspense>
        </CacheBuster>
      </div>
    </HelmetProvider>
  );
}

export default App;